import React from "react";
import Swal from "sweetalert2";
import api from "../../api/axios";

export default function LeaveSidePanel({ leave, role, onClose, onRefresh }) {
  const isDeptHead = role?.toLowerCase() === "department head";
  const isHR = role?.toLowerCase() === "admin" || role?.toLowerCase() === "hr";

  const approveOrReject = async (action) => {
    const result = await Swal.fire({
      title: action === "approve" ? "Approve Leave?" : "Reject Leave?",
      input: "text",
      inputPlaceholder: "Remarks (optional)",
      showCancelButton: true,
      confirmButtonText: action === "approve" ? "Approve" : "Reject",
      confirmButtonColor: action === "approve" ? "#28a745" : "#dc3545",
    });

    if (!result.isConfirmed) return;

    const payload = {
      approve: action === "approve",
      remarks: result.value || "",
    };

    try {
      if (isDeptHead && leave.status === "pending") {
        await api.post(`/hrms/leaves/${leave.id}/department-decision`, payload);
      }
      if (isHR && leave.status === "approved_by_dept") {
        await api.post(`/hrms/leaves/${leave.id}/hr-decision`, payload);
      }
      Swal.fire("Success", `Leave ${action}d successfully`, "success");
      if (onRefresh) onRefresh();
      onClose();
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  return (
    <div
      className="position-fixed top-0 end-0 h-100 bg-white shadow p-4"
      style={{
        width: "380px",
        zIndex: 2000,
        animation: "slideLeft 0.3s ease",
      }}
    >
      <button className="btn-close" onClick={onClose}></button>

      <h4 className="fw-bold mt-3 mb-3">Leave Details</h4>

      <div className="mb-3">
        <strong>Employee:</strong>
        <div>
          {leave.employee.first_name} {leave.employee.last_name}
        </div>
      </div>

      <div className="mb-3">
        <strong>Department:</strong>
        <div>{leave.employee.department}</div>
      </div>

      <div className="mb-3">
        <strong>Leave Type:</strong>
        <div>{leave.type.short_name}</div>
      </div>

      <div className="mb-3">
        <strong>From:</strong> {leave.from_date}
      </div>

      <div className="mb-3">
        <strong>To:</strong> {leave.to_date}
      </div>

      <div className="mb-3">
        <strong>Status:</strong>
        <span className="badge bg-warning text-dark ms-2">{leave.status}</span>
      </div>

      <div className="mt-4 pt-3 border-top">
        {isDeptHead && leave.status === "pending" && (
          <>
            <button
              className="btn btn-success w-100 mb-2"
              onClick={() => approveOrReject("approve")}
            >
              Approve
            </button>
            <button
              className="btn btn-danger w-100"
              onClick={() => approveOrReject("reject")}
            >
              Reject
            </button>
          </>
        )}

        {isHR && leave.status === "approved_by_dept" && (
          <>
            <button
              className="btn btn-success w-100 mb-2"
              onClick={() => approveOrReject("approve")}
            >
              Final Approve
            </button>
            <button
              className="btn btn-danger w-100"
              onClick={() => approveOrReject("reject")}
            >
              Final Reject
            </button>
          </>
        )}
      </div>
    </div>
  );
}
